
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"34","viewBox":"0 0 25 34","width":"25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"height":"22","rx":"3","stroke":"#343440","stroke-width":"2","width":"22","x":"1","y":"10.64"}}),_c('path',{attrs:{"d":"M14.436 20.64l.835-.55a1 1 0 00-1.63-.056zm-3.927 5.159l-.832.555a1 1 0 001.628.05zm9.205 2.841v1a1 1 0 00.835-1.55zm-7.308 0v-1a1 1 0 00-.832 1.555zm0 0v1a1 1 0 00.832-1.555zm-8.12 0l-.792-.61a1 1 0 00.792 1.61zm4.35-5.647l.832-.555a1 1 0 00-1.624-.055zm5.004-2.959l-3.927 5.159 1.592 1.211 3.927-5.158zm6.909 8.055l-5.278-8-1.67 1.102 5.279 8zm-8.143 1.551h7.308v-2h-7.308zm.832-1.555l-1.664 1.11zM4.286 29.64h8.12v-2h-8.12zm3.558-7.257l-4.35 5.647 1.584 1.22 4.35-5.647zm3.497 2.86l-1.873-2.805-1.664 1.11 1.873 2.806z","fill":"#343440"}}),_c('circle',{attrs:{"cx":"8","cy":"17.64","r":"2","stroke":"#343440","stroke-width":"2"}}),_c('path',{attrs:{"d":"M17.987.293a1 1 0 00-1.414 0l-6.364 6.364a1 1 0 101.414 1.414l5.657-5.657 5.657 5.657a1 1 0 101.414-1.414zm.293 17.987V1h-2v17.28z","fill":"#343440"}})])
          )
        }
      }
    